module.exports = __webpack_public_path__ + "img/MASCOTGAMING.aaf58a1b.webp";